/* Shipping Countdown Timer - Alien HUD Edition */
/* INFINITY CALENDAR + AUTO-RESTART LOGIC */
/* V2: Collapsible Holiday Alert Section */

// --- 1. DYNAMIC CALENDAR GENERATOR ---
function getHolidaySchedule() {
    const currentYear = new Date().getFullYear();
    const yearsToGen = [currentYear, currentYear + 1]; 
    let schedule = [];

    yearsToGen.forEach(year => {
        // FIXED DATES
        schedule.push(
            { date: `${year}-01-01`, type: 'CLOSED', name: "NEW YEAR'S DAY" },
            { date: `${year}-12-24`, type: 'EARLY', cutoff: 9, name: "CHRISTMAS EVE" },
            { date: `${year}-12-25`, type: 'CLOSED', name: "CHRISTMAS DAY" },
            { date: `${year}-12-31`, type: 'EARLY', cutoff: 9, name: "NEW YEAR'S EVE" }
        );

        // FLOATING DATES
        schedule.push({ date: getLastWeekday(year, 4, 1), type: 'CLOSED', name: "MEMORIAL DAY" }); // May
        schedule.push({ date: getNthWeekday(year, 8, 1, 1), type: 'CLOSED', name: "LABOR DAY" }); // Sept
        
        const tDayDate = getNthWeekday(year, 10, 4, 4); // Nov
        schedule.push({ date: tDayDate, type: 'CLOSED', name: "THANKSGIVING" });

        // Black Friday (Day after Thanksgiving)
        const tDayObj = new Date(tDayDate + 'T00:00:00');
        tDayObj.setDate(tDayObj.getDate() + 1);
        const bFridayStr = tDayObj.toISOString().split('T')[0];
        schedule.push({ date: bFridayStr, type: 'EARLY', cutoff: 9, name: "BLACK FRIDAY" });
    });
    return schedule;
}

// Helpers for Calendar
function getNthWeekday(year, month, dayOfWeek, n) {
    const date = new Date(year, month, 1);
    let count = 0;
    while (date.getMonth() === month) {
        if (date.getDay() === dayOfWeek) {
            count++;
            if (count === n) return date.toISOString().split('T')[0];
        }
        date.setDate(date.getDate() + 1);
    }
    return null;
}
function getLastWeekday(year, month, dayOfWeek) {
    const date = new Date(year, month + 1, 0);
    while (date.getDay() !== dayOfWeek) date.setDate(date.getDate() - 1);
    return date.toISOString().split('T')[0];
}

// --- 2. LOGIC TO FIND NEXT VALID SHIPPING DAY ---
function getNextShippingSlot(startDate, schedule) {
    let checkDate = new Date(startDate);
    checkDate.setDate(checkDate.getDate() + 1); // Start checking from Tomorrow

    while (true) {
        const dayOfWeek = checkDate.getDay();
        const dateStr = checkDate.toISOString().split('T')[0];
        const holiday = schedule.find(h => h.date === dateStr);

        if (dayOfWeek === 6 || dayOfWeek === 0) {
            checkDate.setDate(checkDate.getDate() + 1);
            continue;
        }

        if (holiday && holiday.type === 'CLOSED') {
            checkDate.setDate(checkDate.getDate() + 1);
            continue;
        }

        let cutoffTime = 14;
        if (holiday && holiday.type === 'EARLY') {
            cutoffTime = holiday.cutoff;
        }

        checkDate.setHours(cutoffTime, 0, 0, 0);
        return { date: checkDate, holidayName: holiday ? holiday.name : null };
    }
}

// --- 3. INJECT STYLES FOR COLLAPSIBLE SECTION ---
function injectHolidayAlertStyles() {
    if (document.getElementById('holiday-alert-styles')) return;
    
    const styleSheet = document.createElement('style');
    styleSheet.id = 'holiday-alert-styles';
    styleSheet.textContent = `
        .holiday-alert-section {
            margin-top: 10px;
            border-top: 1px solid rgba(0, 243, 255, 0.2);
            padding-top: 8px;
        }
        
        .holiday-alert-title {
            font-size: 9px;
            letter-spacing: 1.5px;
            color: #888;
            text-transform: uppercase;
            margin-bottom: 6px;
            padding-left: 2px;
        }
        
        .holiday-alert-item {
            display: flex;
            flex-direction: column;
            padding: 8px 10px;
            background: linear-gradient(135deg, transparent 6px, rgba(0, 243, 255, 0.05) 6px);
            margin-bottom: 4px;
            transition: all 0.2s ease;
            gap: 4px;
            position: relative;
        }
        
        .holiday-alert-item::before,
        .holiday-alert-item::after {
            content: '';
            position: absolute;
            border: 1px solid rgba(0, 243, 255, 0.2);
        }
        
        .holiday-alert-item::before {
            top: 0;
            right: 0;
            bottom: 8px;
            left: 8px;
            border-left: none;
            border-bottom: none;
        }
        
        .holiday-alert-item::after {
            top: 8px;
            right: 8px;
            bottom: 0;
            left: 0;
            border-right: none;
            border-top: none;
        }
        
        .holiday-alert-item:hover {
            background: linear-gradient(135deg, transparent 6px, rgba(0, 243, 255, 0.1) 6px);
        }
        
        .holiday-alert-item:hover::before,
        .holiday-alert-item:hover::after {
            border-color: rgba(0, 243, 255, 0.4);
        }
        
        .holiday-alert-item .event-row-top {
            display: flex;
            align-items: center;
            gap: 6px;
        }
        
        .holiday-alert-item .event-icon {
            font-size: 12px;
            flex-shrink: 0;
        }
        
        .holiday-alert-item .event-name {
            font-size: 11px;
            color: #fff;
            font-weight: 500;
        }
        
        .holiday-alert-item .event-row-bottom {
            display: flex;
            align-items: center;
            gap: 8px;
            padding-left: 18px;
        }
        
        .holiday-alert-item .event-date {
            font-size: 11px;
            color: #999;
        }
        
        .holiday-alert-item .event-status {
            font-size: 8px;
            padding: 2px 5px;
            font-weight: 600;
            letter-spacing: 0.5px;
        }
        
        .holiday-alert-item .event-status.closed {
            background: rgba(255, 42, 42, 0.2);
            color: #ff4444;
        }
        
        .holiday-alert-item .event-status.early {
            background: rgba(255, 174, 0, 0.2);
            color: #ffae00;
        }
        
        .holiday-alert-item.hidden {
            display: none;
        }
        
        .holiday-load-more {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 5px 10px;
            background: linear-gradient(135deg, transparent 5px, transparent 5px);
            color: #00f3ff;
            font-size: 9px;
            letter-spacing: 1px;
            text-transform: uppercase;
            cursor: pointer;
            transition: all 0.3s ease;
            width: 100%;
            position: relative;
            border: none;
        }
        
        .holiday-load-more::before,
        .holiday-load-more::after {
            content: '';
            position: absolute;
            border: 1px dashed rgba(0, 243, 255, 0.3);
        }
        
        .holiday-load-more::before {
            top: 0;
            right: 0;
            bottom: 5px;
            left: 5px;
            border-left: none;
            border-bottom: none;
        }
        
        .holiday-load-more::after {
            top: 5px;
            right: 5px;
            bottom: 0;
            left: 0;
            border-right: none;
            border-top: none;
        }
        
        .holiday-load-more:hover {
            background: rgba(0, 243, 255, 0.1);
        }
        
        .holiday-load-more:hover::before,
        .holiday-load-more:hover::after {
            border-color: rgba(0, 243, 255, 0.5);
        }
        
        .holiday-load-more .load-arrow {
            font-size: 8px;
        }
        
        .holiday-btn-container {
            display: flex;
            flex-direction: column;
            gap: 4px;
            margin-top: 2px;
        }
        
        .holiday-show-less {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 5px 10px;
            background: transparent;
            color: #888;
            font-size: 9px;
            letter-spacing: 1px;
            text-transform: uppercase;
            cursor: pointer;
            transition: all 0.3s ease;
            width: 100%;
            position: relative;
            border: none;
        }
        
        .holiday-show-less::before,
        .holiday-show-less::after {
            content: '';
            position: absolute;
            border: 1px dashed rgba(136, 136, 136, 0.3);
        }
        
        .holiday-show-less::before {
            top: 0;
            right: 0;
            bottom: 5px;
            left: 5px;
            border-left: none;
            border-bottom: none;
        }
        
        .holiday-show-less::after {
            top: 5px;
            right: 5px;
            bottom: 0;
            left: 0;
            border-right: none;
            border-top: none;
        }
        
        .holiday-show-less:hover {
            color: #fff;
            background: rgba(255, 255, 255, 0.05);
        }
        
        .holiday-show-less:hover::before,
        .holiday-show-less:hover::after {
            border-color: rgba(255, 255, 255, 0.3);
        }
        
        .holiday-show-less .load-arrow {
            font-size: 8px;
        }
    `;
    document.head.appendChild(styleSheet);
}

// --- 4. MAIN UPDATE FUNCTION ---
function updateShippingCountdown() {
  const now = new Date();

// DST-aware Pacific time using the browser's built-in timezone engine
const pstParts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false
}).formatToParts(now).reduce((acc, p) => {
    if (p.type !== 'literal') acc[p.type] = p.value;
    return acc;
}, {});

const pstTime = new Date(
    `${pstParts.year}-${pstParts.month}-${pstParts.day}T` +
    `${pstParts.hour}:${pstParts.minute}:${pstParts.second}`
);
const todayStr = `${pstParts.year}-${pstParts.month}-${pstParts.day}`;

    const HOLIDAY_SCHEDULE = getHolidaySchedule();
    let activeHoliday = null;
    let upcomingEvents = []; 

    // Scan Schedule
    for (let h of HOLIDAY_SCHEDULE) {
        if (h.date === todayStr) activeHoliday = h;
        
        // Next 12 upcoming holidays
        const hDate = new Date(h.date + 'T00:00:00'); 
        const diffTime = hDate - pstTime; 
        if (diffTime > 0) upcomingEvents.push(h); 
    }

    const widget = document.querySelector('.alien-hud-widget');
    const cutoffLabel = document.getElementById('timer-cutoff-label');
    
    if (!widget) return;
    
    // Inject styles on first run
    injectHolidayAlertStyles();

    // --- LOGIC A: IS TODAY A "CLOSED" HOLIDAY? ---
    if (activeHoliday && activeHoliday.type === 'CLOSED') {
        widget.classList.add('closed-mode');
        
        document.getElementById('alien-timer-display').innerHTML = 
            `<div style="text-align:center; width:100%; padding:15px 0;">
                <div style="font-size:12px; color:#888; letter-spacing:1px;">OPERATIONS PAUSED</div>
                <div style="font-size:16px; color:#ff2a2a; font-weight:bold; margin-top:5px;">${activeHoliday.name}</div>
             </div>`;
        
        document.getElementById('timer-subtitle').innerText = "PROTOCOL: STANDBY";
        document.getElementById('timer-extra-text').style.display = 'none';
        if (cutoffLabel) cutoffLabel.innerHTML = '<span style="color:#ff2a2a">NO DISPATCH TODAY</span>';
        
        // Render alerts AFTER cutoff label
        renderHolidayAlerts(upcomingEvents, widget);
        return; 
    } 

    // --- LOGIC B: NORMAL DAY / EARLY CUTOFF DAY ---
    widget.classList.remove('closed-mode');
    
    let todayCutoffHour = 14;
    let isWeekend = (pstTime.getDay() === 0 || pstTime.getDay() === 6);
    let todayLabel = "2:00 PM PST";

    if (activeHoliday && activeHoliday.type === 'EARLY') {
        todayCutoffHour = activeHoliday.cutoff;
        const ampm = activeHoliday.cutoff >= 12 ? 'PM' : 'AM';
        const std = activeHoliday.cutoff > 12 ? activeHoliday.cutoff - 12 : activeHoliday.cutoff;
        todayLabel = `${std}:00 ${ampm} PST`;
    }

    const todayTarget = new Date(pstTime);
    todayTarget.setHours(todayCutoffHour, 0, 0, 0);

    if (isWeekend) {
        runNextDispatchSequence(pstTime, HOLIDAY_SCHEDULE, "WEEKEND PROTOCOL");
    } 
    else {
        if (pstTime < todayTarget) {
            runCountdown(pstTime, todayTarget, activeHoliday ? activeHoliday.name : null);
            if (cutoffLabel) cutoffLabel.innerHTML = `<span class="label">CUTOFF PROTOCOL:</span> ${todayLabel}`;
        } else {
            const diffMs = pstTime - todayTarget;
            const minutesPast = Math.floor(diffMs / 60000);

            if (minutesPast < 30) {
                widget.classList.remove('urgent');
                document.getElementById('timer-subtitle').innerText = "STATUS UPDATE";
                document.getElementById('alien-timer-display').innerHTML = 
                    `<div style="text-align:center; width:100%; padding:15px 0;">
                        <div style="font-size:16px; color:#fff; letter-spacing:1px; text-shadow:0 0 5px #fff;">DISPATCH WINDOW</div>
                        <div style="font-size:16px; color:#888; font-weight:bold;">CLOSED</div>
                     </div>`;
                if (cutoffLabel) cutoffLabel.innerHTML = '<span style="color:#888">AWAITING NEXT CYCLE</span>';
                document.getElementById('timer-extra-text').style.display = 'none';
            } else {
                runNextDispatchSequence(pstTime, HOLIDAY_SCHEDULE, "NEXT DISPATCH CYCLE");
            }
        }
    }

    // Render alerts AFTER cutoff label (below it in the widget)
    renderHolidayAlerts(upcomingEvents, widget);
}

function runNextDispatchSequence(pstTime, schedule, subtitleText) {
    const nextSlot = getNextShippingSlot(pstTime, schedule);
    const options = { month: 'short', day: 'numeric' };
    const dateDisplay = nextSlot.date.toLocaleDateString('en-US', options).toUpperCase();

    const subEl = document.getElementById('timer-subtitle');
    const cutoffLabel = document.getElementById('timer-cutoff-label');
    
    subEl.innerText = subtitleText;
    
    if (cutoffLabel) cutoffLabel.innerHTML = `<span class="label" style="color:#00f3ff">TARGET DATE:</span> ${dateDisplay}`;

    runCountdown(pstTime, nextSlot.date, null);
}

function runCountdown(currentPst, targetDate, holidayName) {
    const widget = document.querySelector('.alien-hud-widget');
    widget.style.display = 'block';

    const timerEl = document.getElementById('alien-timer-display');
    if (!document.getElementById('countdown-hours')) {
         timerEl.innerHTML = `
            <div class="time-unit"><div class="time-value" id="countdown-hours">00</div><div class="time-label">HRS</div></div>
            <div class="time-separator">:</div>
            <div class="time-unit"><div class="time-value" id="countdown-minutes">00</div><div class="time-label">MIN</div></div>
            <div class="time-separator">:</div>
            <div class="time-unit"><div class="time-value" id="countdown-seconds">00</div><div class="time-label">SEC</div></div>
         `;
         document.getElementById('timer-extra-text').style.display = 'block';
    }
    
    const subEl = document.getElementById('timer-subtitle');
    if (currentPst < targetDate && targetDate.getDate() === currentPst.getDate()) {
         if (holidayName) subEl.innerHTML = `<span style="color:#ffae00">⚠️ ${holidayName} COUNTDOWN</span>`;
         else subEl.innerText = "TIME REMAINING FOR DISPATCH";
    }

    let diff = targetDate - currentPst;
    if (diff < 0) diff = 0; 

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    
    document.getElementById('countdown-hours').textContent = String(hours).padStart(2, '0');
    document.getElementById('countdown-minutes').textContent = String(minutes).padStart(2, '0');
    document.getElementById('countdown-seconds').textContent = String(seconds).padStart(2, '0');
    
    const isSameDay = targetDate.getDate() === currentPst.getDate();
    if (isSameDay && hours === 0 && minutes < 30) {
        widget.classList.add('urgent');
    } else {
        widget.classList.remove('urgent');
    }
}

// --- 5. HOLIDAY EMOJI MAPPING ---
function getHolidayEmoji(holidayName) {
    const emojiMap = {
        "NEW YEAR'S DAY": "🎆",
        "NEW YEAR'S EVE": "🥂",
        "CHRISTMAS DAY": "🎅",
        "CHRISTMAS EVE": "🎄",
        "THANKSGIVING": "🦃",
        "BLACK FRIDAY": "🛒",
        "MEMORIAL DAY": "🇺🇸",
        "LABOR DAY": "👷"
    };
    return emojiMap[holidayName] || "📅";
}

// --- 6. NEW HOLIDAY ALERTS RENDERER ---
function renderHolidayAlerts(events, widget) {
    // Check if section already exists and get current visible count
    const existingSection = widget.querySelector('.holiday-alert-section');
    let visibleCount = 1; // Start with 1 visible
    
    if (existingSection) {
        // Count how many are currently visible
        const visibleItems = existingSection.querySelectorAll('.holiday-alert-item:not(.hidden)');
        visibleCount = visibleItems.length || 1;
        existingSection.remove();
    }
    
    // If no events, don't render anything
    if (!events || events.length === 0) return;
    
    // Sort events by date (earliest first) and limit to 12
    const sortedEvents = events.sort((a, b) => {
        const dateA = new Date(a.date + 'T00:00:00');
        const dateB = new Date(b.date + 'T00:00:00');
        return dateA - dateB;
    }).slice(0, 12);
    
    // Create section container
    const section = document.createElement('div');
    section.className = 'holiday-alert-section';
    section.setAttribute('data-visible-count', visibleCount);
    section.setAttribute('data-total-count', sortedEvents.length);
    
    // Title
    let html = '<div class="holiday-alert-title">UPCOMING SCHEDULE</div>';
    
    // Build items
    sortedEvents.forEach((evt, index) => {
        const dateParts = evt.date.split('-');
        const shortDate = `${dateParts[1]}/${dateParts[2]}`;
        const isClosed = evt.type === 'CLOSED';
        const statusText = isClosed ? 'CLOSED' : `${evt.cutoff > 12 ? evt.cutoff - 12 : evt.cutoff}${evt.cutoff >= 12 ? 'PM' : 'AM'} CUTOFF`;
        const emoji = getHolidayEmoji(evt.name);
        
        // Show items up to visibleCount
        const hiddenClass = (index >= visibleCount) ? 'hidden' : '';
        
        html += `
            <div class="holiday-alert-item ${hiddenClass}" data-index="${index}">
                <div class="event-row-top">
                    <span class="event-icon">${emoji}</span>
                    <span class="event-name">${evt.name}</span>
                </div>
                <div class="event-row-bottom">
                    <span class="event-date">${shortDate}</span>
                    <span class="event-status ${isClosed ? 'closed' : 'early'}">${statusText}</span>
                </div>
            </div>
        `;
    });
    
    // Button container
    html += '<div class="holiday-btn-container">';
    
    // Add Show Less button if more than 1 is visible (appears on top)
    if (visibleCount > 1) {
        html += `
            <button class="holiday-show-less" onclick="showLessHolidays(this)">
                <span class="load-text">SHOW LESS</span>
                <span class="load-arrow">▲</span>
            </button>
        `;
    }
    
    // Add Load More button if there are more items to show (appears below)
    const remaining = sortedEvents.length - visibleCount;
    if (remaining > 0) {
        html += `
            <button class="holiday-load-more" onclick="loadMoreHolidays(this)">
                <span class="load-text">LOAD MORE (${remaining})</span>
                <span class="load-arrow">▼</span>
            </button>
        `;
    }
    
    html += '</div>';
    
    section.innerHTML = html;
    
    // Insert at the end of the widget (below cutoff protocol)
    widget.appendChild(section);
}

// --- 7. LOAD MORE FUNCTION (Global) ---
window.loadMoreHolidays = function(btn) {
    const section = btn.closest('.holiday-alert-section');
    const items = section.querySelectorAll('.holiday-alert-item[data-index]');
    const btnContainer = section.querySelector('.holiday-btn-container');
    let currentVisible = parseInt(section.getAttribute('data-visible-count')) || 1;
    const totalCount = parseInt(section.getAttribute('data-total-count')) || items.length;
    
    // Show 3 more items
    const newVisible = Math.min(currentVisible + 3, totalCount);
    
    items.forEach((item, index) => {
        if (index < newVisible) {
            item.classList.remove('hidden');
        }
    });
    
    // Update the count
    section.setAttribute('data-visible-count', newVisible);
    
    // Update Load More button or hide it
    const remaining = totalCount - newVisible;
    if (remaining > 0) {
        btn.querySelector('.load-text').textContent = `LOAD MORE (${remaining})`;
    } else {
        btn.style.display = 'none';
    }
    
    // Add Show Less button if not already present (insert at top)
    if (!btnContainer.querySelector('.holiday-show-less')) {
        const showLessBtn = document.createElement('button');
        showLessBtn.className = 'holiday-show-less';
        showLessBtn.setAttribute('onclick', 'showLessHolidays(this)');
        showLessBtn.innerHTML = '<span class="load-text">SHOW LESS</span><span class="load-arrow">▲</span>';
        btnContainer.insertBefore(showLessBtn, btnContainer.firstChild);
    }
};

// --- 8. SHOW LESS FUNCTION (Global) ---
window.showLessHolidays = function(btn) {
    const section = btn.closest('.holiday-alert-section');
    const items = section.querySelectorAll('.holiday-alert-item[data-index]');
    const btnContainer = section.querySelector('.holiday-btn-container');
    const totalCount = parseInt(section.getAttribute('data-total-count')) || items.length;
    
    // Hide all except the first one
    items.forEach((item, index) => {
        if (index > 0) {
            item.classList.add('hidden');
        }
    });
    
    // Reset visible count to 1
    section.setAttribute('data-visible-count', 1);
    
    // Update or show Load More button
    let loadMoreBtn = btnContainer.querySelector('.holiday-load-more');
    if (loadMoreBtn) {
        loadMoreBtn.style.display = 'flex';
        const remaining = totalCount - 1;
        loadMoreBtn.querySelector('.load-text').textContent = `LOAD MORE (${remaining})`;
    }
    
    // Remove Show Less button
    btn.remove();
};

// Initialize
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        updateShippingCountdown();
        setInterval(updateShippingCountdown, 1000);
    });
} else {
    updateShippingCountdown();
    setInterval(updateShippingCountdown, 1000);
}